import { actionFactory, typeFactory } from 'common/store/scope';

export const SET_SELECTED = 'SET_SELECTED';
export const CLEAR_SELECTED = 'CLEAR_SELECTED';

export const setSelected = selected => ({
  type: SET_SELECTED,
  selected,
});

export const clearSelected = () => ({
  type: CLEAR_SELECTED,
});

export const factory = namespace => ({
  ...actionFactory(namespace, {
    setSelected,
    clearSelected,
  }),
  TYPES: typeFactory(namespace, {
    SET_SELECTED,
    CLEAR_SELECTED,
  }),
});

export default factory;
